import { Form, Button, Card } from "react-bootstrap";
import { motion } from "framer-motion";
import { FaArrowRight } from "react-icons/fa";
import { NavLink } from "react-router-dom";
import { useState } from "react";
import { authServices } from "../../APIServices/UserData/authServices";

export default function OTPVerification({
  setNextPage,
  email,
  setEmail,
  name,
  setName,
  roleType,
  setRoleType,
  setLoader,
  loader,
  cardAnim
}) {
  const [otp, setOTP] = useState(["", "", "", "", "", ""]);

  const checkRegistrationSetup = async () => {
    setLoader(true)
    let userData = {
      name, 
      email,
      roleType
    }
    let data = await authServices.checkRegistrationSetup(userData)
    if(data?.status){
      setNextPage(data?.status)
      setEmail(data?.email)
      setName(data?.name)
      setRoleType(data?.roleType)
    }
    setLoader(false)
  }

  const userRegistration = async () => {
    setLoader(true)
    let userData = {
      name,
      email,
      roleType,
      otp : otp.join(""),
    }
    let data = await authServices.userRegistration(userData)
    if (data?.status) {
      setEmail(data?.email)
      setEmail(data?.email)
      setNextPage(data?.status)
      setRoleType(data?.roleType)
    }
    setLoader(false)
  }

  function getTwoInitials(name) {
    if (!name) return "";
    const parts = name.trim().split(/\s+/);
    if (parts.length === 1) {
      return parts[0].slice(0, 2).toUpperCase();
    }
    const first = parts[0][0];
    const last = parts[parts.length - 1][0];
    return (first + last).toUpperCase();
  }

  return (
    <>
      <motion.div key="step2" {...cardAnim}>
        <Card className="border-0 shadow-lg" style={{ borderRadius: "18px", width: 420 }}>
          <Card.Body className="p-4">

            <div className="text-center mb-4">
              <h4 className="fw-bold mb-1">Verify your email</h4>
              <small className="text-muted">
                Enter the 6-digit code sent to
              </small>
            </div>

            <Form.Group className="mb-3">
              <div className="hstack gap-2 mb-3">
                  <h6 className={`bg-primary-subtle p-3 rounded-1 fw-bold m-0`}>
                    {getTwoInitials(name)}
                  </h6>
                  <div>
                  <h6 className="m-0">{name}</h6>
                  <p className="small m-0 text-muted">{email}</p>
                </div>  
              </div>
            </Form.Group>
            <Form.Group className="mb-4 text-center">
              <Form.Label className="mb-2">Verification Code</Form.Label>
              <div className="d-flex justify-content-center gap-2">
                {otp.map((digit, index) => (
                  <Form.Control
                    key={index}
                    type="text"
                    inputMode="numeric"
                    maxLength={1}
                    value={digit}
                    className="text-center interactive-input fw-bold"
                    style={{
                      width: 48,
                      height: 52,
                      fontSize: "1.25rem",
                      borderRadius: "10px"
                    }}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/, "");
                      if (!value) return;

                      const newOtp = [...otp];
                      newOtp[index] = value;
                      setOTP(newOtp);

                      if (index < 5) {
                        document.getElementById(`otp-${index + 1}`).focus();
                      }
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Backspace") {
                        const newOtp = [...otp];
                        newOtp[index] = "";
                        setOTP(newOtp);

                        if (index > 0) {
                          document.getElementById(`otp-${index - 1}`).focus();
                        }
                      }
                    }}
                    id={`otp-${index}`}
                  />
                ))}
              </div>
            </Form.Group>

            <motion.div
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.97 }}
              className="mb-2"
            >
              <Button
                onClick={userRegistration}
                disabled={!otp || loader}
                className="w-100 py-2 fw-bold btn-gradient"
              >
                Verify & Continue <FaArrowRight />
              </Button>
            </motion.div>

            <div className="text-center" style={{ fontSize: 14 }}>
              <div>
                Didn’t receive the code?{" "}
                <NavLink onClick={checkRegistrationSetup} to="#" className="fw-semibold">
                  Resend
                </NavLink>
              </div>
              <div className="mt-1">
                Wrong email?{" "}
                <span
                  className="CP fw-semibold text-primary"
                  onClick={() => setNextPage("startRegistration")}
                >
                  Go back
                </span>
              </div>
            </div>

          </Card.Body>
        </Card>
      </motion.div>
    </>
  );
}
